<template>
  <div>
    <nav id="sidebar" v-if="(desktop || largeDesktop) && showMenu">
      <div>
        <ul class="cd-accordion-menu">
          <tree-item
            :key="index"
            v-for="(menu, index) in targetMenu"
            :menu="menu"></tree-item>
        </ul>
      </div>
    </nav>
    <b-sidebar v-if="mobile || tablet" v-model="sidebar" id="sidebar-mobile" :width="tablet ? '50%' : ''" shadow>
      <template v-slot:title>
        <div class="d-flex flex-nowrap align-items-center justify-content-between">
          <img class="mr-3" src="../assets/logo.svg"/>
          <span class="mr-2">Fill-Bill</span>
          <span>Онлайн</span>
        </div>
      </template>
      <div>
        <ul class="cd-accordion-menu">
          <tree-item
            :key="index"
            v-for="(menu, index) in targetMenu"
            :menu="menu"></tree-item>
        </ul>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
  import TreeItem from './TreeItem'
  import { mapActions, mapMutations, mapState } from 'vuex'

  export default {
    name: 'left-sidebar',
    data () {
      return {
        targetMenu: [
          {
            name: 'packages',
            caption: 'ПАКЕТЫ',
            parent_id: null,
            id: 1,
            link: '/packages',
            children: [
              {
                name: 'packages-list',
                caption: 'Список пакетов',
                parent_id: 1,
                id: 2,
                link: '/packages',
                children: []
              },
              /* {
                name: 'packages-new',
                caption: 'Создать пакет',
                parent_id: 1,
                id: 3,
                link: '/packages/new',
                children: []
              } */
            ]
          },
          {
            name: 'ecr',
            caption: 'РЕЕСТР ЭКСПРЕСС-ГРУЗОВ',
            parent_id: null,
            id: 4,
            link: '/ecr',
            children: [
              {
                name: 'ecr-list',
                caption: 'Список РЭГ',
                parent_id: 4,
                id: 5,
                link: '/ecr',
                children: []
              },
              {
                name: 'house-shipment-list',
                caption: 'Товарные партии',
                parent_id: 4,
                id: 6,
                link: '/ecr/house-shipment',
                children: []
              }
            ]
          },
        ],
        sidebar: true
      }
    },
    components: {
      TreeItem
    },
    mounted () {
      if (this.desktop && this.$route.name !== 'main-container') {
        this.hideMenu()
      }
      if (this.desktop && this.$route.name === 'main-container') {
        this.displayMenu()
      }

      if (!this.hasAccessToPackages) {
        const packagesIndex = this.targetMenu.findIndex((item) => {
          return item.name === 'packages'
        })
        this.targetMenu.splice(packagesIndex, 1)
      }

      if (!this.hasAccessToEcr) {
        const ecrIndex = this.targetMenu.findIndex((item) => {
          return item.name === 'ecr'
        })
        this.targetMenu.splice(ecrIndex, 1)
      }
    },
    computed: {
      hasAccessToPackages () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'list_packages'
        })
        return (hasRights.length > 0)
      },
      hasAccessToEcr () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'list_ecr'
        })
        return (hasRights.length > 0)
      },
      ...mapState(
        {
          userInfo: state => state.authorization.userInfo,
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop,
          showMenu: state => state.showMenu
        }
      )
    },
    methods: {
      isAbleToCreateCommissionShipment () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'create_commissionshipment'
        })
        return (hasRights.length > 0)
      },
      ...mapActions({}),
      ...mapMutations({
        toggleMenu: 'toggleMenu',
        hideMenu: 'hideMenu',
        displayMenu: 'displayMenu'
      })
    },
    watch: {
      '$route' (to) {
        if (this.desktop && to.name === 'main-container') {
          this.displayMenu()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #sidebar, #sidebar-mobile {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    height: 100%;
    flex-grow: 1;
    background: #ECEFF1;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ul {
      padding-left: 0;
      line-height: 1.5em;
      list-style-type: none;
      margin: 0;
    }
  }

  @media screen
  and (min-width: 1024px)
  and (max-width: 1439px) {
    #sidebar {
      min-width: 215px;
      width: 215px;
      max-width: 215px;
      & div {
        position: fixed;
        min-width: 215px;
        width: 215px;
        max-width: 215px;
      }
    }
  }

  @media screen
  and (min-width: 1440px) {
    #sidebar {
      min-width: 315px;
      width: 315px;
      max-width: 315px;
      & div {
        position: fixed;
        min-width: 315px;
        width: 315px;
        max-width: 315px;
      }
    }
  }
</style>
